import { Tooltip } from '@bfe/moly';
import styles from './index.module.scss';
import list, { JudgeItem } from './judges';
import Image from 'next/image';
import { memo } from 'react';
import { useParams, useFm } from '@web3/base-hooks';
import { hybirdOpen } from '@web3/base-utils';

const JudgesList = memo(function JudesArea() {
  const { locale } = useParams();
  const fm = useFm();

  const handleClickJudge = (item: JudgeItem) => {
    const token = item.token || 'BTC';
    const deeplink = `bybitapp://open/home?tab=3&symbol=${token}USDT`;
    const webUrl = `${window.location.origin}/${locale}/trade/spot/${token}/USDT`;
    hybirdOpen(deeplink, webUrl);
  };

  const List = () => (
    <div className={styles.list}>
      {list.map((item, index) => (
        <div key={index} className={styles.item}>
          <Tooltip title={item.name}>
            <Image
              className={styles.icon}
              loader={({ src }) => src}
              src={item.icon}
              alt={item.name}
              width={100}
              height={100}
              onClick={() => handleClickJudge(item)}
            />
          </Tooltip>
        </div>
      ))}
    </div>
  );
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{fm('bybitEliteMentors')}</h2>
      <div className={styles.listWrapper}>
        <List />
      </div>
    </div>
  );
});

export default JudgesList;
